import { applicationState } from '@/states/applicationState';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import { Spin } from '@arkas/coreui';

interface LoadingOverlayProps {
  topMenu: boolean;
  loading: boolean;
  collapseSider: boolean;
  isSmallScreen: boolean;
}

const LoadingOverlay: React.SFC<LoadingOverlayProps> = props => {
  const { loading, topMenu, collapseSider, isSmallScreen } = props;
  return loading ? (
    <div
      className={classnames(
        'loading-overlay',
        !topMenu &&
          !isSmallScreen &&
          (collapseSider ? 'has-collapsed-sider' : 'has-full-sider')
      )}
    >
      <div className="loading-spinner">
        <Spin size="large" style={{ color: '#fff' }} />
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    topMenu: state.appModel.topMenu,
    loading: state.loading.global
  };
};
export default connect(mapStateToProps)(LoadingOverlay);
